// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gPo4","left":"styles_left__34nny"};